import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "arrowhead"
    }}>{`ArrowHead`}</h1>
    <p>{`The shape of one or both ends of an open path.`}</p>
    <h2 {...{
      "id": "class"
    }}>{`Class`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`NONE`}</strong>{` = 1852796517`}</p>
      <p parentName="blockquote">{`None.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`SIMPLE_ARROW_HEAD`}</strong>{` = 1936289136`}</p>
      <p parentName="blockquote">{`An arrow head formed by two slanting lines whose intersection forms a 45-degree angle and whose stroke weight is the same as the path's stroke.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`SIMPLE_WIDE_ARROW_HEAD`}</strong>{` = 1937203560`}</p>
      <p parentName="blockquote">{`An arrow head formed by two slanting lines whose intersection forms a 90-degree angle and whose stroke weight is the same as the path's stroke.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`TRIANGLE_ARROW_HEAD`}</strong>{` = 1953655150`}</p>
      <p parentName="blockquote">{`A solid triangle arrow head whose point describes a 45-degree angle.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`TRIANGLE_WIDE_ARROW_HEAD`}</strong>{` = 1953980776`}</p>
      <p parentName="blockquote">{`A solid triangle arrow head whose point describes a 90-degree angle.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`BARBED_ARROW_HEAD`}</strong>{` = 1650553442`}</p>
      <p parentName="blockquote">{`A solid arrow head whose pierced end bows sharply toward the point and whose point describes a 45-degree angle.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`CURVED_ARROW_HEAD`}</strong>{` = 1668702568`}</p>
      <p parentName="blockquote">{`A solid arrow head whose pierced end concaves toward the point and whose point describes a 45-degree angle.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`CIRCLE_ARROW_HEAD`}</strong>{` = 1668440424`}</p>
      <p parentName="blockquote">{`A hollow circle whose outline is the same weight as the stroke. The circle's diameter is 5 times the stroke width.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`CIRCLE_SOLID_ARROW_HEAD`}</strong>{` = 1668505960`}</p>
      <p parentName="blockquote">{`A solid circle whose diameter is 5 times the stroke width.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`SQUARE_ARROW_HEAD`}</strong>{` = 1936810344`}</p>
      <p parentName="blockquote">{`A hollow square set perpendicular to the path, whose outline is the same weight as the stroke. The length of one side of the square is 5 times the stroke width.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`SQUARE_SOLID_ARROW_HEAD`}</strong>{` = 1936941416`}</p>
      <p parentName="blockquote">{`A solid square set perpendicular to the end of the path. The length of one side of the square is 5 times the stroke width.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`BAR_ARROW_HEAD`}</strong>{` = 1651663208`}</p>
      <p parentName="blockquote">{`A vertical bar bisected by the stroke, which meets the stroke at a right angle and is the same weight as the stroke. The bar's length is 4.5 times the stroke width.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      